document.addEventListener(
  "DOMContentLoaded",
  () => {

    const sections =
      document.querySelectorAll(
        ".editorial-hero"
      );

    if (!sections.length) return;

    const prefersReducedMotion =
      window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches;

    sections.forEach((section) => {

      const image =
        section.querySelector(
          ".editorial-hero__image"
        );

      const badge =
        section.querySelector(
          ".editorial-hero__badge"
        );

      const leftHeading =
        section.querySelector(
          ".editorial-hero__heading--left"
        );

      const rightHeading =
        section.querySelector(
          ".editorial-hero__heading--right"
        );

      /* =====================================
         SKIP IF REDUCED MOTION
      ===================================== */

      if (prefersReducedMotion) return;

      /* =====================================
         MOUSE PARALLAX
      ===================================== */

      section.addEventListener(
        "mousemove",
        (event) => {

          const rect =
            section.getBoundingClientRect();

          const x =
            (event.clientX - rect.left)
            / rect.width;

          const y =
            (event.clientY - rect.top)
            / rect.height;

          const moveX =
            (x - 0.5) * 30;

          const moveY =
            (y - 0.5) * 30;

          if (image) {

            image.style.transform =
              `
              translate3d(
                ${moveX * 0.4}px,
                ${moveY * 0.4}px,
                0
              )
              `;
          }

          if (badge) {

            badge.style.transform =
              `
              translate3d(
                ${moveX * 0.8}px,
                ${moveY * 0.8}px,
                0
              )
              `;
          }

          if (leftHeading) {

            leftHeading.style.transform =
              `
              translate3d(
                ${moveX * -0.15}px,
                ${moveY * -0.15}px,
                0
              )
              `;
          }

          if (rightHeading) {

            rightHeading.style.transform =
              `
              translate3d(
                ${moveX * -0.15}px,
                ${moveY * -0.15}px,
                0
              )
              `;
          }

        }
      );

      /* =====================================
         RESET
      ===================================== */

      section.addEventListener(
        "mouseleave",
        () => {

          [
            image,
            badge,
            leftHeading,
            rightHeading
          ].forEach((element) => {

            if (!element) return;

            element.style.transform =
              "translate3d(0,0,0)";

          });

        }
      );

      /* =====================================
         SCROLL REVEAL
      ===================================== */

      const observer =
        new IntersectionObserver(

          (entries) => {

            entries.forEach(
              (entry) => {

                if (
                  entry.isIntersecting
                ) {

                  section.classList.add(
                    "editorial-hero--visible"
                  );

                  observer.unobserve(
                    entry.target
                  );

                }

              }
            );

          },

          {
            threshold: 0.2
          }

        );

      observer.observe(section);

    });

  }
);